import React from "react";

function ThankYouPage() {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 bg-light text-center p-4">
      <div
        className="bg-white shadow-lg rounded-4 p-5"
        style={{ maxWidth: "600px" }}
      >
        <h1 className="text-success mb-4 fw-bold">धन्यवाद!</h1>
        <p className="fs-5 text-secondary">
          आपण शेडनेट हाऊस अनुदानासाठी अर्ज यशस्वीरित्या सादर केला आहे.
        </p>
        <p className="fs-6 text-muted">
          आपला अर्ज यशस्वीपणे नोंदविण्यात आला असून तपासणीसाठी संबंधित विभागाकडे
          पाठविण्यात आला आहे.
        </p>
        <hr />
        <p className="fs-6 text-secondary">
          कृपया पुढील माहिती किंवा मंजुरीसंबंधी सूचना मिळेपर्यंत प्रतीक्षा करा.
        </p>
        <button
          className="btn btn-success mt-4 px-4 py-2 fw-bold"
          onClick={() => (window.location.href = "/")}
        >
          मुख्य पृष्ठावर जा
        </button>
      </div>
    </div>
  );
}

export default ThankYouPage;
